// src/pages/GioiThieu.jsx
import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function GioiThieu() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-6">
      <Breadcrumb />

      <h1 className="text-2xl font-extrabold text-red-600 mb-4 text-center">
        Giới thiệu
      </h1>

      {/* KHỐI A */}
      <section className="rounded-xl border border-red-200 bg-white text-gray-800 p-4 shadow-sm mb-4">
        <h2 className="font-semibold mb-3 leading-relaxed text-red-700">
          A. Tầm nhìn, Sứ mệnh, Giá trị cốt lõi, Văn hoá doanh nghiệp:
          được thể hiện qua tên công ty, logo, slogan và hai ảnh biểu tượng
        </h2>

        {/* 1. Tên công ty */}
        <div className="mb-3">
          <label className="font-medium">1. Tên công ty: SÂN KHẤU 1122</label>
          <div className="border-b border-dashed border-gray-300 mt-1" />
        </div>

        {/* 2. Slogan */}
        <div className="mb-3">
          <label className="font-medium">2. Slogan: Hổ Mọc Thêm Cánh</label>
          <div className="border-b border-dashed border-gray-300 mt-1" />
        </div>

        {/* 3. Logo */}
        <div className="mb-3">
          <label className="font-medium">3. Logo:</label>
          <figure className="mt-2 rounded-lg border border-gray-300 overflow-hidden bg-gray-50">
            <img
              src="/logo_GioiThieu.jpg"
              alt="Logo công ty"
              loading="lazy"
              className="w-full h-auto object-contain aspect-video"
              sizes="(max-width: 768px) 100vw, 720px"
            />
          </figure>
        </div>

        {/* 4. Ảnh biểu tượng */}
        <div>
          <label className="font-medium">4. Ảnh biểu tượng</label>
          <figure className="mt-2 rounded-lg border border-gray-300 overflow-hidden bg-gray-50">
            <img
              src="/Gioithieu1.jpg"
              alt="Ảnh biểu tượng"
              loading="lazy"
              className="w-full h-auto object-cover aspect-video"
              sizes="(max-width: 768px) 100vw, 720px"
            />
          </figure>
        </div>
      </section>

      {/* ẢNH BÓNG ĐÁ */}
      <section className="rounded-xl border border-red-200 bg-white text-gray-800 p-4 shadow-sm mb-4">
        <figure className="rounded-lg border border-gray-300 overflow-hidden bg-gray-50">
          <img
            src="/Gioithieu2.jpg"
            alt="Ảnh bóng đá"
            loading="lazy"
            className="w-full h-auto object-cover aspect-video"
            sizes="(max-width: 768px) 100vw, 720px"
          />
        </figure>
      </section>

      {/* KHỐI B: Thông tin liên hệ */}
      <section className="rounded-xl border border-red-200 bg-white text-gray-800 p-4 shadow-sm mb-4">
        <h3 className="font-semibold mb-3 text-red-700">B. Thông tin liên hệ:</h3>

        {["Công ty TNHH", "Địa chỉ", "MST", "Điện thoại", "Mail"].map((label) => (
          <div key={label} className="mb-3">
            <div className="font-medium">- {label}:</div>
            <div className="border-b border-dashed border-gray-300 mt-1" />
          </div>
        ))}
      </section>

      {/* KHỐI C: Nhà cung cấp */}
      <section className="rounded-xl border border-red-200 bg-white text-gray-800 p-4 shadow-sm">
        <h3 className="font-semibold mb-3 text-red-700">C. Nhà cung cấp vui lòng liên hệ</h3>

        {["Điện thoại", "Mail"].map((label) => (
          <div key={label} className="mb-3">
            <div className="font-medium">- {label}:</div>
            <div className="border-b border-dashed border-gray-300 mt-1" />
          </div>
        ))}
      </section>
    </div>
  );
}
